import React, { useCallback, useState, useEffect } from "react";
import axios from "axios";
import useSWR from "swr";
import { fetcher } from "./Overview/Overview";

// Component is to be used as an information driven item. ie: it should be passed the current (and correct) value for
// this user. It's actions are based off of this and is considered the 'truth'
// This component should NOT be used if you need to retrieve the current status
export const UserOptionToggle = (props) => {
    const [enabled, setEnabled] = useState(!!props?.enabled);

    const url = `/v1/courses/${props?.courseUUID}/`;

    const toggleOption = useCallback(
        async (enabled) => {
            await axios.patch(url, {
                student_options: [{ user: props?.userUUID, [props.name]: enabled }]
            });
            setEnabled(enabled);

            if (typeof props?.onSuccess === "function") {
                props.onSuccess();
            }
        },
        [props?.name]
    );

    // due to external factors the enabled state could change, this ensures that it follows suit
    useEffect(() => {
        setEnabled(props?.enabled);
    }, [props?.enabled]);

    return (
        <div>
            <input type="checkbox" name={props?.name} disabled={props.disabled} value={enabled} checked={enabled} onChange={(e) => toggleOption(!enabled)} />
        </div>
    );
};

// Wrapper arround the non-current toggle which fetches the current option
export const CurrentUserOptionToggle = (props) => {
    const { data: courseDetails, mutate: mutateCourseDetails } = useSWR(() => (props?.courseUUID ? `/v1/courses/${props.courseUUID}/` : false), fetcher);

    const enabled = courseDetails?.student_options?.find((u) => u.user === props?.userUUID)?.[props?.name] || false;

    return (
        <UserOptionToggle
            userUUID={props?.userUUID}
            courseUUID={props?.courseUUID}
            name={props?.name}
            enabled={enabled}
            onSuccess={props?.onSuccess}
            mutate={props?.mutate}
        />
    );
};
